<template>
  <el-dialog
    title="账号信息"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="account-info-dialog-shell"
    @closed="onDialogClosed"
  >
    <div class="account-info-dialog">
      <div class="acc-block acc-block--avatar">
        <file-upload
          class="acc-avatar-upload"
          action="/image/upload?thumbSize=20"
          :is-permanent="true"
          :show-loading="true"
          :max-size="maxUploadSize"
          :file-types="['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp']"
          @success="onAvatarUploadSuccess"
        >
          <div class="acc-avatar-box" title="上传头像">
            <head-image
              v-if="form.headImageThumb"
              class="acc-avatar-img"
              :size="66"
              :url="form.headImageThumb"
              radius="50%"
              :name="form.nickName || form.userName"
            />
            <div v-else class="acc-avatar-placeholder">
              <i class="el-icon-plus acc-avatar-plus" />
              <span>上传头像</span>
            </div>
          </div>
        </file-upload>
        <div class="acc-avatar-hint">
          <p>建议尺寸1:1，支持.jpg .gif .png格式的</p>
          <p>图片，最大5MB</p>
        </div>
      </div>

      <div class="acc-divider" />

      <div class="acc-block acc-block--fields">
        <div class="acc-field-row">
          <span class="acc-field-label">客服ID：</span>
          <span class="acc-field-value acc-field-value--ellipsis">{{ displayCsId }}</span>
          <button type="button" class="acc-field-action" title="复制" @click="copyCsId">
            <i class="el-icon-document-copy" />
          </button>
        </div>

        <div class="acc-field-row">
          <span class="acc-field-label">客服邮箱：</span>
          <span class="acc-field-value acc-field-value--ellipsis">{{ form.email || "—" }}</span>
        </div>

        <div class="acc-field-row acc-field-row--input">
          <span class="acc-field-label">客服名称：</span>
          <el-input v-model="form.realNameModel" size="small" maxlength="64" placeholder="请输入客服名称" class="acc-field-input" />
          <button type="button" class="acc-field-action" title="保存客服名称" @click="saveProfile({ silent: false })">
            <i class="el-icon-edit" />
          </button>
        </div>

        <div class="acc-field-row acc-field-row--input">
          <span class="acc-field-label">客服昵称：</span>
          <el-input v-model="form.nickName" size="small" maxlength="32" show-word-limit placeholder="请输入昵称" class="acc-field-input" />
          <button type="button" class="acc-field-action" title="保存客服昵称" @click="saveProfile({ silent: false })">
            <i class="el-icon-edit" />
          </button>
        </div>
      </div>

      <p class="acc-footnote">除头像外，账号信息只会展示给团队内成员，客户看不见</p>
    </div>
  </el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "AccountInfoDialog",
  components: {
    FileUpload,
    HeadImage
  },
  data() {
    return {
      dialogVisible: false,
      maxUploadSize: 5 * 1024 * 1024,
      form: {
        userName: "",
        email: "",
        nickName: "",
        realNameModel: "",
        headImage: "",
        headImageThumb: ""
      }
    };
  },
  computed: {
    displayCsId() {
      const u = this.form.userName;
      return u != null && String(u).trim() !== "" ? String(u) : "—";
    }
  },
  methods: {
    open() {
      this.syncFromStore();
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    syncFromStore() {
      const u = this.userStore.userInfo || {};
      this.form = {
        userName: u.userName || "",
        email: u.email || "",
        nickName: u.nickName || "",
        realNameModel: u.realName != null && u.realName !== "" ? u.realName : u.userName || "",
        headImage: u.headImage || "",
        headImageThumb: u.headImageThumb || ""
      };
    },
    onDialogClosed() {
      this.$emit("closed");
    },
    copyCsId() {
      const id = this.form.userName;
      if (id == null || String(id).trim() === "") {
        this.$message.warning("暂无可复制的客服ID");
        return;
      }
      const text = String(id);
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success(`已复制：${text}`);
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      } else {
        this.$message.error("当前环境不支持一键复制");
      }
    },
    onAvatarUploadSuccess(data) {
      this.form.headImage = data.originUrl;
      this.form.headImageThumb = data.thumbUrl;
      const storeUser = this.userStore.userInfo;
      if (storeUser) {
        storeUser.headImage = data.originUrl;
        storeUser.headImageThumb = data.thumbUrl;
      }
      this.saveProfile({ silent: false });
    },
    saveProfile(opts = {}) {
      const silent = opts.silent === true;
      const mine = this.userStore.userInfo;
      if (!mine || !mine.id) {
        return;
      }
      const payload = JSON.parse(JSON.stringify(mine));
      payload.nickName = this.form.nickName;
      payload.headImage = this.form.headImage;
      payload.headImageThumb = this.form.headImageThumb;
      payload.realName = this.form.realNameModel;
      this.$http({
        url: "/user/update",
        method: "put",
        data: payload
      })
        .then(() => {
          this.userStore.loadUser();
          if (!silent) {
            this.$message.success("保存成功");
          }
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.account-info-dialog {
  margin-top: -6px;
}

.acc-block--avatar {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.acc-avatar-upload {
  flex-shrink: 0;
}

.acc-avatar-box {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}

.acc-avatar-img {
  display: block;
}

.acc-avatar-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.2;
}

.acc-avatar-plus {
  font-size: 22px;
  font-weight: 600;
}

.acc-avatar-hint {
  flex: 1;
  min-width: 0;
  padding-top: 8px;
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: 20px; /* 250% */

  p {
    margin: 0;
  }
}

.acc-divider {
  margin: 20px 0;
  // height: 1px;
  // background: linear-gradient(
  //   90deg,
  //   rgba(235, 238, 245, 0) 0%,
  //   rgba(235, 238, 245, 0.45) 10%,
  //   #ebeef5 28%,
  //   #ebeef5 72%,
  //   rgba(235, 238, 245, 0.45) 90%,
  //   rgba(235, 238, 245, 0) 100%
  // );
}

.acc-field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  font-size: 14px;

  & + & {
    margin-top: 4px;
  }
}

.acc-field-label {
  flex-shrink: 0;
  width: 92px;
  color: #000;
  // font-size: 10px;
  font-style: normal;
  font-weight: 350;
  line-height: 20px; /* 200% */
}

.acc-field-value {
  flex: 1;
  min-width: 0;
  color: #303133;

  &--ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.acc-field-row--input .acc-field-label {
  padding-top: 2px;
}

.acc-field-input {
  flex: 1;
  min-width: 0;
}

.acc-field-action {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  &:hover {
    background: #f3f4f6;
    color: #409eff;
  }
}

.acc-footnote {
  margin: 20px 0 20px 0;
  font-size: 12px;
  line-height: 1.5;
  color: #000817;
}
</style>

<style lang="scss">
/* el-dialog 挂载在 body */
.account-info-dialog-shell.el-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.account-info-dialog-shell .el-dialog__header {
  padding: 18px 22px 12px;
  text-align: left;
  // border-bottom: 1px solid #f0f2f5;
}

.account-info-dialog-shell .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.account-info-dialog-shell .el-dialog__body {
  padding: 18px 22px 22px;
}
</style>
